/* tslint:disable */
/* eslint-disable */
/**
 * Courtiers API
 * API des listes de courtiers (facettes, tri, scope compagnie/admin)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConnexionListItem } from './ConnexionListItem';
import {
    ConnexionListItemFromJSON,
    ConnexionListItemFromJSONTyped,
    ConnexionListItemToJSON,
    ConnexionListItemToJSONTyped,
} from './ConnexionListItem';

/**
 * 
 * @export
 * @interface GetConnexionListResponse
 */
export interface GetConnexionListResponse {
    /**
     * 
     * @type {number}
     * @memberof GetConnexionListResponse
     */
    totalCount: number;
    /**
     * 
     * @type {Array<ConnexionListItem>}
     * @memberof GetConnexionListResponse
     */
    items: Array<ConnexionListItem>;
}

/**
 * Check if a given object implements the GetConnexionListResponse interface.
 */
export function instanceOfGetConnexionListResponse(value: object): value is GetConnexionListResponse {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function GetConnexionListResponseFromJSON(json: any): GetConnexionListResponse {
    return GetConnexionListResponseFromJSONTyped(json, false);
}

export function GetConnexionListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConnexionListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['totalCount'],
        'items': ((json['items'] as Array<any>).map(ConnexionListItemFromJSON)),
    };
}

export function GetConnexionListResponseToJSON(json: any): GetConnexionListResponse {
    return GetConnexionListResponseToJSONTyped(json, false);
}

export function GetConnexionListResponseToJSONTyped(value?: GetConnexionListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalCount': value['totalCount'],
        'items': ((value['items'] as Array<any>).map(ConnexionListItemToJSON)),
    };
}

